import React from 'react';
import {
  Box,
  Flex,
  Drawer,
  DrawerBody,
  Icon,
  useColorModeValue,
  DrawerOverlay,
  useDisclosure,
  DrawerContent,
  DrawerCloseButton,
} from '@chakra-ui/react';
import Content from 'components/sidebar/components/Content';
import {
  renderThumb,
  renderTrack,
  renderView,
} from 'components/scrollbar/Scrollbar';
import { Scrollbars } from 'react-custom-scrollbars-2';
import PropTypes from 'prop-types';
import { IoMenuOutline } from 'react-icons/io5';


const getFilteredRoutes = (routes) => {
  // let { routes } = props;
  let filteredRoutes = routes ? routes.filter(route => route.path !== '/notifications') : [];
  let user = JSON.parse(localStorage.getItem('user'));

  if (user?.role !== 'admin') {
    filteredRoutes = filteredRoutes.filter(
      (route) => route.name !== 'AI Powered Meeting'
    );
  }

  if (user?.role === 'admin') {
    filteredRoutes = filteredRoutes.filter((route) => route.name !== 'Upload files');
  }

  if (user?.role === 'schemeAdmin') {
    filteredRoutes = filteredRoutes.filter(
      (route) => !['Master Data'].includes(route.name),
    );
  }

  if (user?.role === 'talukaUser') {
    filteredRoutes = filteredRoutes.filter(
      (route) => !['Users', 'Master Data'].includes(route.name),
    );
  }

  if (user?.role === 'subDivisionalOfficer') {
    filteredRoutes = filteredRoutes.filter(
      (route) => !['Users', 'Master Data'].includes(route.name),
    );
  }

  if (user?.role === 'projectOfficer') {
    filteredRoutes = filteredRoutes.filter(
      (route) => !['Users', 'Master Data'].includes(route.name),
    );
  }
  return filteredRoutes;
};
function Sidebar(props) {
  const { routes } = props;
  const filteredRoutes = getFilteredRoutes(routes);

  const sidebarBg = useColorModeValue(
    'linear-gradient(180deg, #f8fafc 0%, #f1f5f9 100%)',
    'linear-gradient(180deg, #1e293b 0%, #0f172a 100%)'
  );

  const sidebarBorder = useColorModeValue('gray.200', 'gray.700');
  const sidebarShadow = useColorModeValue(
    '0 8px 32px rgba(0, 0, 0, 0.08), inset 0 1px 0 rgba(255, 255, 255, 0.8)',
    '0 8px 32px rgba(0, 0, 0, 0.3), inset 0 1px 0 rgba(255, 255, 255, 0.1)'
  );

  return (
    <Box
      display={{ sm: 'none', xl: 'block' }}
      w="100%"
      position="fixed"
      minH="100%"
    >
      <Box
        bg={sidebarBg}
        w="300px"
        h="100vh"
        minH="100%"
        overflowX="hidden"
        boxShadow={sidebarShadow}
        borderRight="1px solid"
        borderColor={sidebarBorder}
        position="relative"
        sx={{
          "&::before": {
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            height: "4px",
            background: "linear-gradient(90deg, #1e40af, #3b82f6, #1e40af)",
          }
        }}
      >
        <Scrollbars
          autoHide
          renderTrackVertical={renderTrack}
          renderThumbVertical={renderThumb}
          renderView={renderView}
        >
          <Content routes={filteredRoutes} />
        </Scrollbars>
      </Box>
    </Box>
  );
}

export function SidebarResponsive(props) {
  const { routes } = props;
  const filteredRoutes = getFilteredRoutes(routes);

  let sidebarBackgroundColor = useColorModeValue(
    'linear-gradient(180deg, #f8fafc 0%, #f1f5f9 100%)',
    'linear-gradient(180deg, #1e293b 0%, #0f172a 100%)'
  );
  let menuColor = useColorModeValue('gray.600', 'gray.300');

  const { isOpen, onOpen, onClose } = useDisclosure();
  const btnRef = React.useRef();


  return (
    <Flex display={{ sm: 'flex', xl: 'none' }} alignItems="center">
      <Flex
        ref={btnRef}
        w="max-content"
        h="max-content"
        onClick={onOpen}
        bg={useColorModeValue('white', 'gray.800')}
        p="2"
        borderRadius="md"
        border="1px solid"
        borderColor={useColorModeValue('gray.200', 'gray.700')}
        boxShadow="sm"
        _hover={{
          boxShadow: 'md',
          transform: 'translateY(-1px)',
        }}
        transition="all 0.2s"
      >
        <Icon
          as={IoMenuOutline}
          color={menuColor}
          w="20px"
          h="20px"
        />
      </Flex>
      <Drawer
        isOpen={isOpen}
        onClose={onClose}
        placement={document.documentElement.dir === 'rtl' ? 'right' : 'left'}
        finalFocusRef={btnRef}
      >
        <DrawerOverlay />
        <DrawerContent
          w="285px"
          maxW="285px"
          bg={sidebarBackgroundColor}
          borderRight="1px solid"
          borderColor={useColorModeValue('gray.200', 'gray.700')}
          position="relative"
          sx={{
            "&::before": {
              content: '""',
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              height: "4px",
              background: "linear-gradient(90deg, #1e40af, #3b82f6, #1e40af)",
            }
          }}
        >
          <DrawerCloseButton
            zIndex="3"
            onClose={onClose}
            _focus={{ boxShadow: 'none' }}
            _hover={{ boxShadow: 'none' }}
            top="10px"
            right="10px"
            bg={useColorModeValue('white', 'gray.800')}
            borderRadius="full"
            w="30px"
            h="30px"
          />
          <DrawerBody maxW="285px" px="0rem" pb="0" pt="20px">
            <Scrollbars
              autoHide
              renderTrackVertical={renderTrack}
              renderThumbVertical={renderThumb}
              renderView={renderView}
            >
              <Content routes={filteredRoutes} />
            </Scrollbars>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </Flex>
  );
}

Sidebar.propTypes = {
  logoText: PropTypes.string,
  routes: PropTypes.arrayOf(PropTypes.object),
  variant: PropTypes.string,
};

export default Sidebar;